import {
	computed,
	ComputedRef,
	ref,
	Ref,
	watch,
	WatchSource,
	WatchStopHandle,
} from '@vue/composition-api';

// eslint-disable-next-line arrow-body-style
type toComputed1 = <A, T>(fn: (arg1: A) => T) => (arg1: Ref<A>) => ComputedRef<T>;

/**
 * Converts a single-argument function to a reactive version which takes in a Ref,
 * and returns a computed value of the result
 *
 * @param fn The function to convert
 * @returns The updated function whose arguments are refs and whose return is a ComputedRef
 */
export const toComputed: toComputed1 = (fn) => (arg) => computed(() => fn(arg.value));

export interface SyncedRef<T> {
	ref: Ref<T>;
	stop: WatchStopHandle;
}

export function syncedRef<T>(source: WatchSource<T>): SyncedRef<T> {
	const syncedRefVal: Ref<T> = ref(null) as unknown as Ref<T>;
	const stop = watch(source, (curr) => {
		syncedRefVal.value = curr;
	}, { immediate: true });
	return {
		ref: syncedRefVal,
		stop,
	};
}
